import { EndpointKey } from '../../http/EndpointKey';
export const getRetriesInitialState = () => {
  // setting the retry count to 0 for every endpoint registered
  const retriesInitialState = Object.values(EndpointKey).reduce((acc, key) => {
    acc[key] = 0;
    return acc;
  }, {});
  return retriesInitialState;
};